import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { DateTime } from 'luxon';

import {
  FilterState,
  FilterStateValue,
  isDisplayValuePair,
  isKeyValuePair,
} from './filter-state.service';

@Injectable({
  providedIn: 'root',
})
export class FilterParameterService {
  constructor() {}

  getFilterParameters(params: HttpParams, filters?: FilterState[]): HttpParams {
    if (!filters || filters.length === 0) {
      return params;
    }

    Object.keys(filters).forEach((filterKey) => {
      filters[filterKey]?.values.forEach((value: FilterStateValue) => {
        if (value instanceof DateTime) {
          params = params.append(filterKey, value.toISODate());
        } else {
          params = params.append(
            filterKey,
            `${isKeyValuePair(value) ? value.id : isDisplayValuePair(value) ? value.value : value}`
          );
        }
      });
    });

    return params;
  }

  getFilterParametersWithIndividualDateParams(
    params: HttpParams,
    filters?: FilterState[]
  ): HttpParams {
    if (!filters || filters.length === 0) {
      return params;
    }

    Object.keys(filters).forEach((filterKey) => {
      const filter = filters[filterKey];
      filter.values.forEach(
        (value: FilterStateValue, index: number) => {
          if (value instanceof DateTime) {
            if (index == 0) {
              params = params.append(`${filterKey}From`, value.toISODate());
            } else {
              params = params.append(`${filterKey}To`, value.toISODate());
            }
          } else {
            params = params.append(
              filterKey,
              `${isKeyValuePair(value) ? value.id : isDisplayValuePair(value) ? value.value : value}`
            );
          }
        }
      );
    });

    return params;
  }

  // Converts an object to HttpParams
  toHttpParams(obj: any): HttpParams {
    let params = new HttpParams();

    for (const key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] != null) {
        const value = obj[key];

        if (Array.isArray(value)) {
          // Handle arrays by appending each value with the same key
          value.forEach((item) => {
            if (item != null) {
              params = params.append(key, item.toString());
            }
          });
        } else if (typeof value === 'boolean' || value) {
          // Handle non-array values
          params = params.set(key, value.toString());
        }
      }
    }

    return params;
  }
}
